// extracted by css-extract-rspack-plugin
export default {"truncateBranch":"PullRequestBranchName-module__truncateBranch__lWQmdRY"};